import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { reportRenderers } from "./reportRenderers";
import { requestParameters } from "actions/report";
import { ReporteInfo } from "Interfaces/IParameters";
import LottieLoader from "react-lottie-loader";
import { AnimationContainer } from "Views/SSRS/styled.component";

export const ReportViewer = () => {
  const { id } = useParams<{ id: string }>();
  const [reporte, setReporte] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const loaderConfig = require("../../../data/loader_animation.json");

  useEffect(() => {
    if (!id) return;

    const abortController = new AbortController();

    requestParameters(Number(id))
      .then((data: ReporteInfo | null) => {
        if (!abortController.signal.aborted) {
          setReporte(data);
        }
      })
      .finally(() => {
        if (!abortController.signal.aborted) {
          setLoading(false);
        }
      });

    return () => abortController.abort();
  }, [id]);

  if (loading)
    return (
      <AnimationContainer>
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
          <LottieLoader animationData={loaderConfig} className={"animation"} />
          <div>Cargando reporte...</div>
        </div>
      </AnimationContainer>
    );

  if (!reporte) {
    return <div>No se encontró el reporte</div>;
  }

  const Renderer = reportRenderers[reporte.idTipoReporte];

  if (!Renderer) {
    return <div>Tipo de reporte no soportado</div>;
  }

  return <Renderer reporte={reporte} />;
};
